import { format, isValid, parseISO } from 'date-fns'

/**
 * Derive a display label from a camelCase key. A trailing digit group is spaced off the word it
 * follows ('mailingAddress1' → 'Mailing Address 1'), matching how the schema labels such fields.
 */
export function formatLabel(key: string): string {
  return (
    key.charAt(0).toUpperCase() +
    key
      .slice(1)
      .replace(/([A-Z])/g, ' $1')
      .replace(/(\d+)/g, ' $1')
  )
}

/** Format a value for read-only display */
export function formatValue(value: unknown): string | null {
  if (value === null || value === undefined || value === '') {
    return null
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  if (typeof value === 'number') {
    return value.toLocaleString()
  }
  return String(value)
}

/** Format an ISO date string (YYYY-MM-DD) as MM/DD/YYYY for display */
export function formatIsoDateMMDDYYYY(iso: unknown): string | null {
  if (typeof iso !== 'string' || iso === '') {
    return null
  }
  const parsed = parseISO(iso)
  if (!isValid(parsed)) {
    return null
  }
  return format(parsed, 'MM/dd/yyyy')
}
